export const customCssId = 'wix-custom-css'
export const pageId = 'masterPage'
export const CUSTOM_CSS_APP_ID = '081cfa21-cdf6-4f50-9a1b-0f3722acfd8b'
export const GLOBAL_CSS_OLD_NAMESPACE = '#SITE_CONTAINER #main_MF .css-editing-scope'
export const GLOBAL_CSS_NAMESPACE = '#SITE_CONTAINER #main_MF#main_MF .css-editing-scope'
export const GLOBAL_CSS_SELECTOR_PREFIX = 'wixui-'
export const GLOBAL_CSS_FILE_PATH = '/styles/global.css'
export const APP_CSS_FILE_PATH = '/styles/widget.css'
export const EXCLUDE_PAGES = ['dashboardPage', 'panelPage']
